import dot from 'dot-object'

let content = {}

export const setContent = (newContent = {}) => {
  content = newContent
}

export const translate = (key, defaultValue) => {
  return dot.pick(key, content) || defaultValue
}
